(function () {
  'use strict';

  if (window.EPSizeChart) return;

  var CACHE_TTL = 24 * 60 * 60 * 1000;
  var FAILURE_TTL = 30 * 1000;
  var CACHE_PREFIX = 'ep-size-chart-stretch-v1:';
  var endpoint = window.EPSizeChartEndpoint || 'https://sizechart.ever-pretty.com/api/flat';
  var flatRequests = new Map();
  var requestQueue = [];
  var activeRequests = 0;

  function normalizeStyleNo(styleNo) {
    return typeof styleNo === 'string' ? styleNo.trim().toUpperCase() : '';
  }

  function stretchValue(flat) {
    return typeof flat.stretch === 'string' ? flat.stretch.trim() : null;
  }

  function saveStretch(styleNo, stretch) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + styleNo, JSON.stringify({
        stretch: stretch,
        expires: Date.now() + CACHE_TTL
      }));
    } catch (_) {}
  }

  function cachedStretch(styleNo) {
    try {
      var cacheKey = CACHE_PREFIX + styleNo;
      var value = window.sessionStorage.getItem(cacheKey);
      if (!value) return null;
      var cached = JSON.parse(value);
      if (cached && typeof cached.expires === 'number' && cached.expires > Date.now() &&
          (cached.stretch === null || typeof cached.stretch === 'string')) {
        return cached;
      }
      window.sessionStorage.removeItem(cacheKey);
    } catch (_) {}
    return null;
  }

  async function fetchFlat(styleNo) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 8000);

    try {
      var response = await fetch(endpoint + '?sku=' + encodeURIComponent(styleNo), {
        signal: controller.signal,
        credentials: 'omit'
      });
      if (!response.ok) throw new Error('Size chart request failed with status ' + response.status);
      var flat = await response.json();
      if (!flat || typeof flat !== 'object' || Array.isArray(flat)) {
        throw new Error('Invalid size chart response');
      }
      return flat;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function drainQueue() {
    while (activeRequests < 4 && requestQueue.length) {
      var request = requestQueue.shift();
      activeRequests++;
      fetchFlat(request.styleNo).then(request.resolve, request.reject).finally(function () {
        activeRequests--;
        drainQueue();
      });
    }
  }

  function getFlat(styleNo) {
    styleNo = normalizeStyleNo(styleNo);
    if (!styleNo) return Promise.reject(new Error('A style number is required'));

    var existing = flatRequests.get(styleNo);
    if (existing && existing.expires > Date.now()) return existing.promise;

    var entry = { expires: Infinity };
    entry.promise = new Promise(function (resolve, reject) {
      requestQueue.push({ styleNo: styleNo, resolve: resolve, reject: reject });
    }).then(function (flat) {
      entry.expires = Date.now() + CACHE_TTL;
      saveStretch(styleNo, stretchValue(flat));
      return flat;
    }, function (error) {
      entry.expires = Date.now() + FAILURE_TTL;
      throw error;
    });
    flatRequests.set(styleNo, entry);
    drainQueue();
    return entry.promise;
  }

  function getStretch(styleNo) {
    styleNo = normalizeStyleNo(styleNo);
    if (!styleNo) return Promise.resolve(null);

    var existing = flatRequests.get(styleNo);
    if (existing && existing.expires > Date.now()) return existing.promise.then(stretchValue);

    var cached = cachedStretch(styleNo);
    if (cached) return Promise.resolve(cached.stretch);
    return getFlat(styleNo).then(stretchValue);
  }

  window.EPSizeChart = { getFlat: getFlat, getStretch: getStretch };
})();
